import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Link,
  Box,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import SnusProductDetailContent from './SnusProductDetailContent';
import { buildSnusProductDetailPath } from './snusProductUtils';

/**
 * Compact product detail dialog for Sweden snus SKUs (separate from JTI ProductDetailPopup).
 */
export default function SnusProductDetailPopup({
  open,
  onClose,
  detail,
  loading,
  error,
  skuKey,
  country,
  brand,
  category,
  week,
  retailerTable,
}) {
  const fullPath =
    skuKey && buildSnusProductDetailPath(skuKey, { country, brand, category, week, retailerTable });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle sx={{ pr: 6 }}>
        Product detail
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <SnusProductDetailContent detail={detail} loading={loading} error={error} compact />
        {fullPath && !loading && !error && detail && (
          <Box sx={{ mt: 2 }}>
            <Link component={RouterLink} to={fullPath} variant="body2" onClick={onClose}>
              View full product details →
            </Link>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
